import { setStoreName as updateStoreName } from '../../../context/dsUserInsights';
import { useStoreNameData, setStoreNameData } from '../context/storeNameAtoms';

export function useStoreNameInput() {
  const { selectedSuggestion } = useStoreNameData();

  function handleStoreNameChange(newValue: string) {
    updateStoreName(newValue);
    setStoreNameData({
      currentStoreName: newValue,
      ...(selectedSuggestion && newValue !== selectedSuggestion ? { selectedSuggestion: '' } : {}),
    });
  }

  function handleSuggestionSelect(option: { value: string; label: string }) {
    setStoreNameData({
      selectedSuggestion: option.value,
      currentStoreName: option.value,
    });
    updateStoreName(option.value);
  }

  return {
    handleStoreNameChange,
    handleSuggestionSelect,
  };
}
